<template>
  <div class="profile-dropdown">
    <button
      class="dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :aria-label="$t('profile')"
    >
      <img :src="getUserAvatar()" class="profile-img" :alt="$t('profile')" style="width: 40px; height: 40px; object-fit: cover;" />
      <span class="md-none">
        <span class="d-block fw-bold text-title">{{ userFullName }}</span>
        <span class="text-paragraph fs-14">{{ user ? (user.username || $t("header.user")) : $t("header.please_login") }}</span>
      </span>
    </button>
    <div class="dropdown-menu top-1 shadow-none border-0">
      <ul class="list-style">
        <li class="fs-14 d-block transition text-dark fw-bold border-bottom pb-2 mb-2">
          <!-- {{ user?.email || 'No Email' }} -->
          {{ userFullName }}
        </li>
        <li class="fs-14 d-block transition">
          <router-link to="/my-profile" class="d-block">
            {{ $t("my_profile") }}
          </router-link>
        </li>
        <li class="fs-14 d-block transition">
          <router-link to="/system-settings" class="d-block">
            {{ $t("system_settings") }}
          </router-link>
        </li>
        <li class="fs-14 d-block transition">
          <a href="#" class="d-block" @click.prevent="handleLogout"> {{ $t("logout") }} </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { authService } from "../../../services/auth";
import { useCurrentUser } from "../../../composables/useCurrentUser";
import { buildAssetUrl, buildStorageAssetUrl } from "../../../utils/settings";
import defaultAvatarImg from "../../../assets/img/users/user-default.jpg";

export default defineComponent({
  name: "ProfileDropdown",
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const { currentUser, fetchCurrentUser } = useCurrentUser();
    const defaultAvatar = defaultAvatarImg;

    const getUserAvatar = () => {
      if (currentUser.value && currentUser.value.avatar && String(currentUser.value.avatar).trim() !== '') {
        if (!String(currentUser.value.avatar).startsWith('http')) {
           if (String(currentUser.value.avatar).startsWith("uploads/")) {
             return buildAssetUrl(String(currentUser.value.avatar));
           }
           return buildStorageAssetUrl(String(currentUser.value.avatar));
        }
        return currentUser.value.avatar;
      }
      return defaultAvatar;
    };

    const userFullName = computed(() => {
      if (!currentUser.value) return t("header.guest");
      return `${currentUser.value.first_name || ""} ${currentUser.value.last_name || ""}`.trim() || currentUser.value.username || t("header.user");
    });

    const handleLogout = async () => {
      try {
        await authService.logout();
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        router.push("/login");
      }
    };

    onMounted(() => {
      fetchCurrentUser(true);
    });

    return {
      handleLogout,
      getUserAvatar,
      user: currentUser,
      userFullName,
      defaultAvatar,
    };
  },
});
</script>

<style lang="scss" scoped>
.profile-dropdown {
  img {
    border-radius: 5px;
    margin-right: 10px;
  }
  .dropdown-toggle {
    &:after {
      display: none;
    }
  }
  span {
    &:nth-child(1) {
      margin-bottom: 5px;
    }
    &:nth-child(2) {
      color: #8a939b;
    }
  }
  .dropdown-menu {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15) !important;
    padding: 14px 20px;
    top: 20px !important;
    ul {
      li {
        margin-bottom: 7px;
        padding-bottom: 7px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.03);
        &:last-child {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: none;
        }
        a {
          &:hover {
            color: var(--secondaryColor);
            padding-left: 5px;
          }
        }
      }
    }
  }
}
</style>
